import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material';
import { PaginatedModel } from 'src/app/dominio/paginated-model';
import { PaginatorServiceV2 } from '../../services/paginator-service-v2';
import { CarregandoService } from 'src/app/services/carregando.service';
import { QueryFilterService } from '../../services/query-filter-service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { AnaliseCreditoIntegradorModel } from "src/app/dominio/analise-credito-integrador-model";
import {
  AlterarAnaliseCreditoIntegradorRequest,
  AnaliseCreditoIntegradorService,
  CadastrarAnaliseCreditoIntegradorRequest,
} from "../../services/analise-credito-integrador.service";
import { AnaliseCreditoService } from "../../services/analise-credito.service";
import { AnaliseCreditoModel } from "../../../dominio/analise-credito-model";
import { SelectBoxV2Model } from "../../../dominio/ui/select-box-v2-model";

interface AnaliseCreditoIntegrador extends AnaliseCreditoIntegradorModel {
  editando: boolean;
  tiposDisponiveis: AnaliseCreditoModel[];
  semRegistro?: boolean;
}

@Component({
  selector: "app-analise-credito-integrador",
  templateUrl: "./analise-credito-integrador.component.html",
  styleUrls: ["./analise-credito-integrador.component.scss"],
})
export class AnaliseCreditoIntegradorComponent implements OnInit {
  @Input() idIntegrador: number;

  @ViewChild("paginator", { static: false }) paginator: MatPaginator;
  paginador: PaginatedModel;

  tiposAnalises: AnaliseCreditoModel[] = [];
  tipoSituacaoAnalise: SelectBoxV2Model<number>[] = [
    { id: 1, label: "Apto" },
    { id: 2, label: "Não Apto" },
    { id: 3, label: "Bloqueado" },
  ];
  analisesIntegrador: AnaliseCreditoIntegrador[] = [];
  analisesIntegradorBackup: AnaliseCreditoIntegrador[] = [];

  constructor(
    private paginatorServiceV2: PaginatorServiceV2,
    private carregandoService: CarregandoService,
    private queryFilterService: QueryFilterService,
    private notificacaoService: NotificacaoService,
    private analiseCreditoService: AnaliseCreditoService,
    private analiseCreditoIntegradorService: AnaliseCreditoIntegradorService
  ) {}

  ngOnInit() {
    this.paginador = this.paginatorServiceV2.createInstance();

    this.buscarTiposAnalises();
    this.buscarAnalisesIntegrador();
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.paginador.page = pageEvent.pageIndex + 1;
    this.paginador.pageSize = this.paginatorServiceV2.setPageSize(pageEvent.pageSize);

    this.buscarAnalisesIntegrador();
  }

  buscarTiposAnalises() {
    this.carregandoService.mostra("buscarAnalises");

    const queryFilter = this.queryFilterService.getQueryBuilder().addCondition("situacao", "=", 1).build();

    this.analiseCreditoService.listar(queryFilter).subscribe(
      (data) => {
        this.tiposAnalises = data.results;
        this.carregandoService.esconde("buscarAnalises");
      },
      (erro) => {
        this.carregandoService.esconde("buscarAnalises");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarAnalisesIntegrador() {
    this.carregandoService.mostra("buscarAnalisesIntegrador");

    const queryFilter = this.queryFilterService
      .getQueryBuilder()
      .setPage(this.paginador.page)
      .setPageSize(this.paginador.pageSize)
      .addOrderBy("criadoEm", true)
      .build();

    this.analiseCreditoIntegradorService.listar(this.idIntegrador, queryFilter).subscribe(
      (data) => {
        this.analisesIntegrador = (data.results as AnaliseCreditoIntegrador[]).map(analise => {
          if (analise.id == null) {
            analise.id = analise.idAnaliseCredito;
            analise.semRegistro = true;
          }
          return analise;
        });
        this.paginador = this.paginatorServiceV2.createInstance(data.pagination);
        this.carregandoService.esconde("buscarAnalisesIntegrador");
      },
      (erro) => {
        this.carregandoService.esconde("buscarAnalisesIntegrador");
        this.notificacaoService.erro(erro);
      }
    );
  }

  novo() {
    const idsJaUsados: number[] = [];
    this.analisesIntegrador.forEach(a => {
      if (a.analiseCredito != null) {
        const id = a.analiseCredito.id;
        if (id != null) {
          idsJaUsados.push(id);
        }
      }
    });

    const analise: AnaliseCreditoIntegrador = {
      id: this.getNextId(),
      idAnaliseCredito: null,
      idCliFor: this.idIntegrador,
      analisadoPor: null,
      criadoEm: null,
      atualizadoEm: null,
      situacao: 2,
      analiseCredito: {
        id: null,
      },
      tiposDisponiveis: this.tiposAnalises.filter(t => idsJaUsados.indexOf(t.id) === -1),
      editando: true,
    };

    this.analisesIntegrador.unshift(analise);
  }

  editar(idAnalise: number) {
    const analise = this.analisesIntegrador.find((x) => x.idAnaliseCredito === idAnalise);

    if (analise == null) {
      return;
    }

    analise.editando = true;

    this.analisesIntegradorBackup.push(Object.assign({}, analise));
  }

  salvar(idAnalise: number) {
    const analise = this.analisesIntegrador.find((x) => x.idAnaliseCredito === idAnalise);

    if (analise == null) {
      return;
    }

    this.carregandoService.mostra("salvar");

    if (analise.id > 0 && !analise.semRegistro) {
      const data: AlterarAnaliseCreditoIntegradorRequest = {
        situacao: analise.situacao,
      };

      this.analiseCreditoIntegradorService.alterar(this.idIntegrador, analise.id, data).subscribe(
        (resp) => {
          analise.analisadoPor = resp.result.analisadoPor;
          analise.criadoEm = resp.result.criadoEm;
          analise.atualizadoEm = resp.result.atualizadoEm;
          analise.situacao = resp.result.situacao;
          analise.editando = false;

          this.carregandoService.esconde("salvar");
          this.notificacaoService.sucesso("Análise de crédito alterada com sucesso!");
          this.buscarAnalisesIntegrador();
        },
        (erro) => {
          this.carregandoService.esconde("salvar");
          this.notificacaoService.erro(erro);
        }
      );
    } else {
      const data: CadastrarAnaliseCreditoIntegradorRequest = {
        idAnaliseCredito: analise.analiseCredito.id,
        situacao: analise.situacao,
      };

      this.analiseCreditoIntegradorService.cadastrar(this.idIntegrador, data).subscribe(
        (resp) => {
          analise.id = resp.result.id;
          analise.semRegistro = false;
          analise.analisadoPor = resp.result.analisadoPor;
          analise.criadoEm = resp.result.criadoEm;
          analise.atualizadoEm = resp.result.atualizadoEm;
          analise.situacao = resp.result.situacao;
          analise.analiseCredito = resp.result.analiseCredito;
          analise.editando = false;

          this.carregandoService.esconde("salvar");
          this.notificacaoService.sucesso("Análise de crédito cadastrada com sucesso!");
          this.buscarAnalisesIntegrador();
        },
        (erro) => {
          this.carregandoService.esconde("salvar");
          this.notificacaoService.erro(erro);
        }
      );
    }
  }

  cancelar(idAnalise: number) {
    const analise = this.analisesIntegrador.find((x) => x.idAnaliseCredito === idAnalise);

    if (analise == null) {
      return;
    }

    if (analise.id > 0 || analise.semRegistro) {
      const backup = this.analisesIntegradorBackup.find((x) => x.id === idAnalise);

      analise.editando = false;

      if (backup != null) {
        const idx = this.analisesIntegradorBackup.indexOf(backup);

        analise.analisadoPor = backup.analisadoPor;
        analise.criadoEm = backup.criadoEm;
        analise.atualizadoEm = backup.atualizadoEm;
        analise.situacao = backup.situacao;
        analise.analiseCredito = backup.analiseCredito;

        this.analisesIntegradorBackup.splice(idx, 1);
      }
    }
    else {
      analise.editando = false;
    }
  }

  retornaSituacaoAnalise(idSituacao: number): string {
    const situacao = this.tipoSituacaoAnalise.find((x) => x.id === idSituacao);

    if (situacao == null) {
      return "indefinido";
    }

    return situacao.label;
  }

  retornaExpiracao(analise: AnaliseCreditoIntegrador): string {
    if (analise.dataExpiracao == null) {
      return 'Validade Indefinida';
    }
    const d = new Date(analise.dataExpiracao);
    return d.toLocaleDateString('pt-BR');
  }

  getNextId() {
    const min = Math.min(...this.analisesIntegrador.map((x) => x.id));

    return Number.isFinite(min) ? (Math.abs(min) + 1) * -1 : -1;
  }
}
